/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * One cash-priced itinerary from the Google Flights search-results page. Parsed from the per-row screen-reader aria-label. Display-only; not bookable.
 * @export
 * @interface GoogleFlightOffer
 */
export interface GoogleFlightOffer {
    /**
     * 
     * @type {number}
     * @memberof GoogleFlightOffer
     */
    price: number;
    /**
     * 
     * @type {string}
     * @memberof GoogleFlightOffer
     */
    currency: string;
    /**
     * Carrier(s) as Google renders them, e.g. "Frontier" or "Delta, United".
     * @type {string}
     * @memberof GoogleFlightOffer
     */
    airline: string;
    /**
     * 
     * @type {number}
     * @memberof GoogleFlightOffer
     */
    stops: number;
    /**
     * Full airport name from the label, e.g. "Denver International Airport".
     * @type {string}
     * @memberof GoogleFlightOffer
     */
    departureAirport: string;
    /**
     * 
     * @type {string}
     * @memberof GoogleFlightOffer
     */
    arrivalAirport: string;
    /**
     * 
     * @type {Date}
     * @memberof GoogleFlightOffer
     */
    departsAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof GoogleFlightOffer
     */
    arrivesAt: Date;
    /**
     * 
     * @type {number}
     * @memberof GoogleFlightOffer
     */
    durationMinutes: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof GoogleFlightOffer
     */
    layovers?: Array<string>;
    /**
     * Requested origin IATA, e.g. "DEN".
     * @type {string}
     * @memberof GoogleFlightOffer
     */
    origin?: string;
    /**
     * Requested destination IATA.
     * @type {string}
     * @memberof GoogleFlightOffer
     */
    destination?: string;
    /**
     * Optional airline-direct booking deep link for the carrier, when mapped. Omitted when unknown (populated in a later phase).
     * @type {string}
     * @memberof GoogleFlightOffer
     */
    airlineDirectUrl?: string;
    /**
     * Marketing flight number(s) from segment data, e.g. "AA171" for direct or "AA518/AA819" for connections. Null when segment data is unavailable.
     * @type {string}
     * @memberof GoogleFlightOffer
     */
    flightNumber?: string;
    /**
     * Cabin class of this offer, e.g. "economy", "premium_economy", "business", "first". Mirrors the cabin requested in the search.
     * @type {string}
     * @memberof GoogleFlightOffer
     */
    cabinClass?: string;
    /**
     * Set only when this offer came from a round-trip search. Google prices both legs in one call and returns outbound itineraries carrying the round-trip total, so when this is present `price` covers both directions and every other field on this offer describes the outbound leg only. Absent on one-way searches.
     * @type {Date}
     * @memberof GoogleFlightOffer
     */
    returnDate?: Date;
    /**
     * Loyalty points/miles required to book this itinerary via a matched award program. Null when no points pricing is available.
     * @type {number}
     * @memberof GoogleFlightOffer
     */
    pointsCost?: number;
    /**
     * Cash component (taxes and fees) of the points booking, in the currency indicated by points_currency_code.
     * @type {number}
     * @memberof GoogleFlightOffer
     */
    pointsCashCost?: number;
    /**
     * Currency code for points_cash_cost, e.g. "USD".
     * @type {string}
     * @memberof GoogleFlightOffer
     */
    pointsCurrencyCode?: string;
    /**
     * Loyalty program that offers the points pricing, e.g. "american".
     * @type {string}
     * @memberof GoogleFlightOffer
     */
    pointsSource?: string;
}

/**
 * Check if a given object implements the GoogleFlightOffer interface.
 */
export function instanceOfGoogleFlightOffer(value: object): value is GoogleFlightOffer {
    if (!('price' in value) || value['price'] === undefined) return false;
    if (!('currency' in value) || value['currency'] === undefined) return false;
    if (!('airline' in value) || value['airline'] === undefined) return false;
    if (!('stops' in value) || value['stops'] === undefined) return false;
    if (!('departureAirport' in value) || value['departureAirport'] === undefined) return false;
    if (!('arrivalAirport' in value) || value['arrivalAirport'] === undefined) return false;
    if (!('departsAt' in value) || value['departsAt'] === undefined) return false;
    if (!('arrivesAt' in value) || value['arrivesAt'] === undefined) return false;
    if (!('durationMinutes' in value) || value['durationMinutes'] === undefined) return false;
    return true;
}

export function GoogleFlightOfferFromJSON(json: any): GoogleFlightOffer {
    return GoogleFlightOfferFromJSONTyped(json, false);
}

export function GoogleFlightOfferFromJSONTyped(json: any, ignoreDiscriminator: boolean): GoogleFlightOffer {
    if (json == null) {
        return json;
    }
    return {
        
        'price': json['price'],
        'currency': json['currency'],
        'airline': json['airline'],
        'stops': json['stops'],
        'departureAirport': json['departure_airport'],
        'arrivalAirport': json['arrival_airport'],
        'departsAt': (new Date(json['departs_at'])),
        'arrivesAt': (new Date(json['arrives_at'])),
        'durationMinutes': json['duration_minutes'],
        'layovers': json['layovers'] == null ? undefined : json['layovers'],
        'origin': json['origin'] == null ? undefined : json['origin'],
        'destination': json['destination'] == null ? undefined : json['destination'],
        'airlineDirectUrl': json['airline_direct_url'] == null ? undefined : json['airline_direct_url'],
        'flightNumber': json['flight_number'] == null ? undefined : json['flight_number'],
        'cabinClass': json['cabin_class'] == null ? undefined : json['cabin_class'],
        'returnDate': json['return_date'] == null ? undefined : (new Date(json['return_date'])),
        'pointsCost': json['points_cost'] == null ? undefined : json['points_cost'],
        'pointsCashCost': json['points_cash_cost'] == null ? undefined : json['points_cash_cost'],
        'pointsCurrencyCode': json['points_currency_code'] == null ? undefined : json['points_currency_code'],
        'pointsSource': json['points_source'] == null ? undefined : json['points_source'],
    };
}

export function GoogleFlightOfferToJSON(json: any): GoogleFlightOffer {
    return GoogleFlightOfferToJSONTyped(json, false);
}

export function GoogleFlightOfferToJSONTyped(value?: GoogleFlightOffer | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'price': value['price'],
        'currency': value['currency'],
        'airline': value['airline'],
        'stops': value['stops'],
        'departure_airport': value['departureAirport'],
        'arrival_airport': value['arrivalAirport'],
        'departs_at': value['departsAt'].toISOString(),
        'arrives_at': value['arrivesAt'].toISOString(),
        'duration_minutes': value['durationMinutes'],
        'layovers': value['layovers'],
        'origin': value['origin'],
        'destination': value['destination'],
        'airline_direct_url': value['airlineDirectUrl'],
        'flight_number': value['flightNumber'],
        'cabin_class': value['cabinClass'],
        'return_date': value['returnDate'] == null ? value['returnDate'] : value['returnDate'].toISOString().substring(0,10),
        'points_cost': value['pointsCost'],
        'points_cash_cost': value['pointsCashCost'],
        'points_currency_code': value['pointsCurrencyCode'],
        'points_source': value['pointsSource'],
    };
}

